// Registry of controls whose backend does not exist yet. Delete an entry to
// remove its "Not yet implemented" banner and unlock the wrapped control.
export const UNFINISHED = {
  versions: { label: 'Versions and run numbers', ticket: 'brainstorm-bjjg.2' },
  canvasSaveAsTask: { label: 'Save the canvas as a task', ticket: 'brainstorm-bjjg.5' },
  saveBranchAsTask: { label: 'Save a branch as a task', ticket: 'brainstorm-bjjg.5' },
  planModeQuestions: { label: 'Plan-mode step questions', ticket: 'brainstorm-bjjg.6' },
  orgPublic: { label: 'Public tasks in your organisation', ticket: 'brainstorm-bjjg.7' },
  inputSourceDatabase: { label: 'Database query', ticket: 'brainstorm-bjjg.8' },
  inputSourceStorage: { label: 'Storage', ticket: 'brainstorm-bjjg.8' },
  inputSourceEmail: { label: 'From an email', ticket: 'brainstorm-bjjg.8' },
  taskLastRun: { label: 'Last run and cost per task', ticket: 'brainstorm-bjjg.13' },
  pinTasks: { label: 'Pin tasks to the top', ticket: 'brainstorm-bjjg.14' },
  inputSourceLink: { label: 'Link', ticket: 'brainstorm-bjjg.8' },
  taskRuns: { label: 'Runs of this task', ticket: 'brainstorm-bjjg.20' },
  partialRuns: { label: 'Run part of a task', ticket: 'brainstorm-bjjg.21' },
  taskEdits: { label: 'Save edits as a new version', ticket: 'brainstorm-bjjg.22' },
  runEstimate: { label: 'Cost estimate before a run', ticket: 'brainstorm-bjjg.23' },
  saveStepsAsTask: { label: 'Save steps as a new task', ticket: 'brainstorm-bjjg.5' },
};

export function isUnfinished(key, registry = UNFINISHED) {
  return Object.prototype.hasOwnProperty.call(registry, key);
}
